<template>
  <div>
    <b-container>
      <div class="mt-4 mb-2 row d-flex justify-content-between justify-content-between">
        <div class="col-8">
          <back-arrow :bilan-type="bilanType"
                      :params="{operationId: this.operationId, operationType: this.operationType}"
                      :sub-title-ope="this.operationName"
                      :title="$t('ScheduleGlobalEdit')"
                      route-back="ScheduleShow"/>
        </div>
        <div class="col-4 justify-content-end d-flex">
        </div>


      </div>

      <b-card v-if="needSchedule">
        <div class="mt-2">
          <div class="row mx-2">
            <b-form v-unsave-detector class="col-12 no-gutters mx-0 my-0" @submit.stop.prevent="onSubmit">
              <b-form-group
                class="col-6 mb-0"
                label="Lots concernés"
                label-for="operation-lot">
                <select-tags-field
                  :items="operationLotsFormatted"
                  :itemsInit="operationLotsFormatted"
                  :placeholder="$t('Schedule.SelectLots')"
                  @didChangeSelectedItems="handleSelectedLots"
                ></select-tags-field>
              </b-form-group>

              <schedule-vir-vefa
                :initial-schedule="templateSchedule"
                :need-amount-preview="false"
                @schedule-changed="scheduleChanged"></schedule-vir-vefa>
              <div class="d-flex justify-content-end">
                <b-button type="submit" variant="primary">{{ $t('Appliquer') }}</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </b-card>
    </b-container>

  </div>
</template>

<script>

import api from "../../../services/api"
import backArrow from "../../../components/b122/BackArrow";
import ScheduleVirVefa from "../components/ScheduleVirVefa";
import SelectTagsField from "../../../components/b122/editFields/SelectTagsField";
import Swal from "sweetalert2";

export default {
  name: "ScheduleGlobalEdit",

  components: {
    backArrow,
    ScheduleVirVefa,
    SelectTagsField
  },

  props: {
    operationId: {
      type: String,
      default: null
    },
  },

  data() {
    return {
      operationLots: [],
      bilanType: null,
      operationName: null,
      currentSection: 0,
      templateSchedule: null,
      operationType: null,
      selectedLotIds: [],
      isTemplateValide: true,
    }
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    operationLotsFiltered() {
      if (this.operationType === 'DEFAULT') return []
      else if (this.operationType === 'VIR') return this.operationLots.filter(lot => lot.isLotVir)
      return this.operationLots
    },
    needSchedule() {
      return this.operationType && this.operationType !== 'DEFAULT'
    },

    operationLotsFormatted() {
      return this.operationLotsFiltered.map(lot => ({
        id: lot.id || `temp-${lot.name}`,
        tostring: lot.name,
      }));
    },
  },

  methods: {

    handleSelectedLots(selectedLotIds) {
      this.selectedLotIds = selectedLotIds;
    },

    async fetchData() {
      await this.getOperationLots()
      if (this.operationId) {
        await this.getOperation()
      }
    },

    scheduleChanged(schedule, isValid) {
      this.templateSchedule = schedule
      this.isTemplateValide = isValid
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.bilanType = response.data.bilanType
            this.operationName = response.data.name
            this.templateSchedule = response.data.schedule
            this.operationType = response.data.operationType
          })
      }
    },

    async onSubmit() {
      if (this.selectedLotIds.length === 0) {
        this.$alert('Veuillez sélectionner au moins un lot.', 'Attention', 'warning');
        return;
      }
      if(!this.isTemplateValide) {
        this.$alert('Le modèle d’échéancier n’est pas valide.', 'Erreur', 'error');
        return;
      }

      const selectedLotNames = this.operationLotsFiltered
        .filter(lot => this.selectedLotIds.includes(lot.id || `temp-${lot.name}`))
        .map(lot => `<li>${lot.name}</li>`)
        .join('');

      try {
        const confirmed = await this.$confirm(
          '',
          'Confirmation',
          'warning',
          {
            html: `<div style="text-align: left;">
            <p>Vous êtes sur le point d'appliquer ce nouvel échéancier aux lots suivants :</p>
            <ul style="margin-top: 10px; margin-bottom: 15px;">
              ${selectedLotNames}
            </ul>
            <p><strong>Attention :</strong> Cette action remplacera les échéanciers existants pour ces lots.</p>
            <p style="margin-top: 15px;">Êtes-vous sûr de vouloir continuer ?</p>
           </div>`,
            confirmButtonText: 'Oui, appliquer',
            cancelButtonText: 'Annuler',
            reverseButtons: true,
            customClass: {
              popup: 'custom-popup-class',
              content: 'custom-content-class'
            }
          }
        );

        if (confirmed) {
          const result = await this.applyScheduleToLot();
          if (!result) {
            return;
          }

          await this.generateMonthlyCharges();

          await this.$router.push({
            name: 'ScheduleShow',
            params: {operationId: this.operationId, operationType: this.operationType}
          });
        }
      } catch (error) {
        console.error('Opération annulée ou erreur:', error);
      }
    },

    async generateMonthlyCharges() {

      let data = new FormData()
      data.append('operationId', this.operationId)

      api({
        method: 'POST',
        url: '/treasury/generateMonthlyCharges',
        data: data
      })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationShow',
              params: {
                operationId: this.operationId,
                currentSection: 2,
                message: error.response.data.message
              }
            })
          }
        })
    },

    async applyScheduleToLot() {

      let success = true;
      let data = new FormData()

      data.append('operationId', this.operationId)
      data.append('schedule', JSON.stringify(this.templateSchedule))
      data.append('operationLots', JSON.stringify(this.selectedLotIds))


      await api({
        method: 'POST',
        url: `/operation/applySchedule/${this.operationId}/`,
        data: data
      })
        .then(() => {

        })
        .catch((error) => {
          success = false
          if (error.response.status === 401 || error.response.status === 404 || 403) {
            this.$router.push({
              name: 'ScheduleShow',
              params: {operationId: this.operationId, operationType: this.operationType}
            });
          }
        })

      return success;
    },


    async getOperationLots() {
      if (this.operationId) {
        await this.getOperationLotsFromOperation()
      }
    },

    async getOperationLotsFromOperation() {
      await api
        .get(`/operationLot/getAllForOperation/${this.operationId}`)
        .then(response => {
          this.operationLots = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },
  }
}
</script>

<style scoped>
.custom-popup-class {
  max-width: 500px;
}

.custom-content-class {
  font-size: 14px;
}

.custom-popup-class ul {
  margin-left: 20px;
}

.custom-popup-class li {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/operation/OperationSchedule/ScheduleGlobalEdit.vue